import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MenuItem } from "../../components/mainnav/menuItem";
import { NavService } from "../../services/nav.service";

@Component({
        standalone: false,
    selector: "home",
    templateUrl: "./home.component.html",
})
export class HomeComponent {
    entities: MenuItem[] = [];
    url: string = "/";

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private navService: NavService
    ) {
        this.entities = navService.getSiteMenu();

        (this.entities as any).forEach((x) => {
            x.options = [
                {
                    value: "Go",
                    id: x.id,
                    controller: this,
                    row: x.url,
                    click: (controller: this, id: number, row: any) =>
                        this.goTo(row),
                },
            ];
        });
    }

    private goTo(url: string) {
        this.router.navigate([url], { relativeTo: this.route });
    }
}
